import {Button, ButtonProps} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import "./style.less"
import "../style.less"

function AddActionButton(props: Partial<ButtonProps>) {
  const {className = "", ...rest} = props

  return (
    <Button
      size="middle"
      shape="default"
      type="primary"
      icon={<PlusOutlined />}
      aria-label={props.children ? undefined : "Додати"}
      title={props.children ? undefined : "Додати"}
      className={`action-button addAction_button ${className}`}
      {...rest}
    >{props.children}</Button>
  )
}

export default AddActionButton
